import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const csmExperienceChatConfigurationRoute: InvariantJiraRoute = {
	name: 'csm-experience-chat-configuration',
	path: '/jira/customer-service-management/experiences/:projectKey/settings/:helpCenterId/chat',
	exact: true,
};
